import {Patient} from "./patient.model";
import {roundToNearestHalf} from "./roundToNearestHalf";

export class SedationResults {
  
  sufX: number;
  sufY: number;
  midNacl: number;
  midX: number;
  midY: number;
  midDose: string;
  vent0: string;
  vent1: string;
  vent2: string;
  vent3: string;
  vent4: string;

  constructor(patient: Patient) {
    this.initResults(patient)
  }

  initResults(patient: Patient) {
    this.sufX = Math.round((4.8 * patient.weight * 10)) / 10;
    this.sufY = Math.round((4.8 * patient.weight) * 2) / 100;

    if(patient.computeAgeYears() < 15){
      this.midNacl = 24;
    }
    else {
      this.midNacl = 50;
    }

    if (patient.weight > 50) {
      this.midX = 50;
      this.midY = 10;
      let speed = roundToNearestHalf(patient.weight * 0.1);
      this.midDose = `IVC débit vit ${speed} <=> 0.1 mg/kg/h`
    }
    else {
      this.midX = Math.trunc((2.4 * patient.weight) * 10) / 10;
      this.midY = Math.round((2.4 * patient.weight) * 2) / 10;
      this.midDose = "IVC débit vit 1 <=> 0.1 mg/kg/h"
    }


    if (patient.weight < 10) {
      this.vent0 = "Mode Pression VP(A)C ou PC BIPAP";
      this.vent1 = "Pression inspiratoire → 18-20cm H2O";
      this.vent3 = "PEP → 2-6 cmH20 (sauf cardiaque, < 10kg)";
      this.vent4 = "P max → 30 cmH20";
    }
    else {
      this.vent0 = "Mode Volume (VC)";
      this.vent1 = "Volume courant : 6-8ml/kg → " + roundToTens(6 * patient.weight) + "-" + roundToTens(8 * patient.weight) + " ml";
      this.vent3 = "PEP → 0-5 cmH20";
      this.vent4 = "P max → 40 cmH20";
    }

    this.vent2 = "Fréquence pour le poids → " + frequence(patient.weight) + " Cycles/mn";
  }
}

function frequence(weight) {
  if (weight >= 30) return "12-18";
  else if (weight >= 20) return "14-22";
  else if (weight >= 15) return "20-25";
  else if (weight >= 10) return "20-30";
  else if (weight >= 5) return " 25-45";
  else return "40-60";
}

function roundToTens(n: number) {
  return Math.round(n / 10) * 10;
}



// WEBPACK FOOTER //
// ./src/models/sedation-results.model.ts